// @flow
import React from 'react';
import { Link } from 'react-router';
import {
  Row,
  Col,
  Button,
  Image,
  FormControl,
  Glyphicon
} from 'react-bootstrap';
import editcampaign from '../../images/edit-campaign.png';
import { LinkContainer } from 'react-router-bootstrap';
import PaginatedList from '../../components/PaginatedList';
import type { User } from '../../types';

type Props = {
  currentOrganisation: any,
  userId: ?number,
  currentOrgId: any,
  users: User[],
  context: string,
  getUsers: Function,
  getFilteredUsers: Function
};

type State = {
  showArchived: boolean,
  filterValue: string,
  currentItemName?: string
};

class UserSidebar extends React.Component<Props, State> {
  screenReaderContent: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      showArchived: false,
      filterValue: ''
    };
  }

  componentDidMount() {
    const { context } = this.props;
    if (context === 'global') {
      this.props.getUsers();
    } else {
      this.props.getUsers(this.props.currentOrganisation.id);
    }
  }

  updateFilterValue = (event: any) => {
    this.props.getFilteredUsers(event.target.value || '');
  };

  moveFocusToHeading = (item: Object) => {
    this.setState({ currentItemName: item.name }, () =>
      this.screenReaderContent.focus()
    );
  };

  render() {
    const { userId, currentOrgId, users, context } = this.props;
    const LineItem = props => {
      const { item } = props;

      return (
        <Row
          key={item.id}
          className={`sidebar-list-item ${item.isArchived && 'archived'}`}
          onClick={e => this.moveFocusToHeading(item)}
        >
          <Link to={`/${context}/${currentOrgId}/users/${item.id}`}>
            <Col
              sm={10}
              className={`overflow-ellipsis map-link ${
                userId === item.id.toString() ? 'active' : ''
              }`}
            >
              {item.email ? (
                <div>
                  <p title={item.name}>
                    <strong>{item.name}</strong>
                  </p>
                  <div>
                    <small title={`Email address: ${item.email}`}>
                      {item.email}
                    </small>
                  </div>
                </div>
              ) : (
                <p title={item.name} className="single-line">
                  <strong>{item.name}</strong>
                </p>
              )}
            </Col>
          </Link>
          <Link to={`/${context}/${currentOrgId}/users/${item.id}`}>
            <Col sm={2} className="edit-btn text-center campaign-edit-link">
              <Image src={editcampaign} responsive alt="Edit User" />
              <span className="campaign-edit-link-text">Edit</span>
            </Col>
          </Link>
        </Row>
      );
    };

    return (
      <div className="generic-sidebar">
        <Row>
          <Col sm={12} md={6}>
            <h3
              className="screen-reader-only"
              tabIndex="-1"
              ref={i => (this.screenReaderContent = i)}
            >
              Editing User {this.state.currentItemName}
            </h3>
            <h1>Users</h1>
          </Col>
          {context !== 'global' && (
            <Col sm={12} md={6}>
              <div className="sidebar-new-btn">
                <LinkContainer to={`/${context}/${currentOrgId}/users/invite`}>
                  <Button bsStyle="primary" className="new-btn">
                    Create New
                  </Button>
                </LinkContainer>
              </div>
            </Col>
          )}

          <Col sm={12}>
            <div className="filter-box">
              <FormControl
                placeholder="Filter"
                onChange={this.updateFilterValue.bind(this)}
              />
              <Button type="submit" className="search">
                <Glyphicon glyph="search" />
              </Button>
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <PaginatedList
              filterValue={this.state.filterValue}
              itemsPerPage={10}
              component={LineItem}
              pageButtonLimit={5}
              items={users}
              keys={
                context === 'global' ? ['id', 'email', 'name'] : ['id', 'name']
              }
              showArchived={this.state.showArchived}
              pluralName="users"
            />
          </Col>
        </Row>

        <Row>
          <Col sm={12} md={12} lg={12} className="show-archived-wrapper">
            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                name="archiveCheckbox"
                id="archiveCheckbox"
                className="archive-checkbox"
                checked={this.state.showArchived}
                onChange={() =>
                  this.setState({ showArchived: !this.state.showArchived })
                }
              />
              <label htmlFor="archiveCheckbox" className="checkbox-label">
                Show Archived
              </label>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default UserSidebar;



// WEBPACK FOOTER //
// ./src/components/sidebars/UserSidebar.js